export default __webpack_public_path__ + "img/daOTeRHt.0a266fd6.svg";